// DAS-65: silver 단일 팔레트. variant(v1/v2) 전환은 토큰을 바꾸지 않음.
// getThemeColors() / useThemeColors() 시그니처·반환 키 집합을 100% 보존하여 Recharts 회귀를 방지한다.

// silver 팔레트 상수 (index.css :root 값과 1:1 동일)
const SILVER_COLORS = {
    surface: "#09090b",
    surfaceCard: "#111113",
    surfaceElevated: "#18181b",
    surfaceBorder: "#27272a",
    surfaceBorderLight: "#3f3f46",
    content: "#fafafa",
    contentSecondary: "#a1a1aa",
    contentMuted: "#71717a",
    brand: "#d4d4d8",
    brandLight: "#fafafa",
    brandDark: "#a1a1aa",
    brandAccent: "#a1a1aa",
    gain: "#22c55e",
    gainLight: "#4ade80",
    gainDark: "#16a34a",
    loss: "#ef4444",
    lossLight: "#f87171",
    lossDark: "#dc2626",
    warning: "#f59e0b",
    warningLight: "#fbbf24",
    brandSubtle: "rgba(255, 255, 255, 0.06)",
    gainSubtle: "rgba(34, 197, 94, 0.15)",
    lossSubtle: "rgba(239, 68, 68, 0.15)",
    warningSubtle: "rgba(245, 158, 11, 0.15)",
    warningText: "#f59e0b",
    surfaceHover: "#222225",
    surfaceCardAlt: "#141416",
    surfaceCardBright: "#141416",
};

export function getThemeColors() {
    return { ...SILVER_COLORS };
}

export function useThemeColors() {
    // silver 단일 팔레트 — MutationObserver 불필요. 상수 반환.
    return SILVER_COLORS;
}
